import React, { useState } from 'react';
import { ReduxState } from 'interfaces';
import { connect, ConnectedProps } from 'react-redux';
import { Card } from 'utilities/components';
import { Input } from '30pay/components';
import { Link } from 'react-router-dom';
import { EditPhoneNumberModal } from './editPhoneNumberModal/editPhoneNumberModal.index';

const ProfileCredential: React.FC<ConnectedProps<typeof connector>> = function (
    props: ConnectedProps<typeof connector>,
) {
    const [editPhoneNumberModalOpen, setEditPhoneNumberModalOpen] = useState<boolean>(false);
    return (
        <Card title="اطلاعات حساب" className={"flex-1"}>
            <EditPhoneNumberModal open={editPhoneNumberModalOpen} setOpen={setEditPhoneNumberModalOpen} phoneNumber={props.user?.phoneNumber} />
            <div className="flex flex-col gap-4">
                <div className="flex items-center gap-6 max-lg:flex-col max-lg:gap-4">
                    <div className="flex flex-col gap-2 w-full">
                        <div className="flex items-center gap-2 w-full">
                            <label className="font-bold text-base text-black-100 max-lg:text-sm">موبایل:</label>
                            <div className="flex-1" />
                            <span className="text-primary-100 text-sm font-bold clickable max-lg:text-sm" onClick={() => setEditPhoneNumberModalOpen(true)}>ویرایش شماره موبایل</span>
                        </div>
                        <Input value={props.user?.phoneNumber ?? 'ثبت نشده'} disabled />
                    </div>
                    <div className="flex flex-col gap-2 w-full">
                        <div className="flex items-center gap-2 w-full">
                            <label className="font-bold text-base text-black-100 max-lg:text-sm">رمز عبور:</label>
                            <div className="flex-1" />
                            <Link to={'/security'} className="text-primary-100 text-sm font-bold clickable max-lg:text-sm">ویرایش رمز عبور</Link>
                        </div>
                        <Input value={'********'} disabled />
                    </div>
                </div>
                <div className="flex flex-col gap-2 w-full">
                    <div className="flex items-center gap-2 w-full">
                        <label className="font-bold text-base text-black-100 max-lg:text-sm">ایمیل:</label>
                        <div className="flex-1" />
                        <span className="text-primary-100 text-sm font-bold clickable max-lg:text-sm">ویرایش ایمیل</span>
                    </div>
                    <Input value={props.user?.emailAddress ?? 'ثبت نشده'} disabled />
                </div>
            </div>
        </Card>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    isAuth: state.authStatus,
    user: state.userData,
});

const connector = connect(mapStateToProps);
export default connector(ProfileCredential);
